import axiosServices from "../utils/axios";

import { fetchSingleCsof } from "./sofDocuments";

export const fetchSof = async (
    page: number,
    pageSize: number,
    jobId?: string,
  ) => {
    const response = await axiosServices.get("/csof", {
      params: {
        page: page + 1,
        start: page * pageSize,
        limit: pageSize,
        ...(jobId && { job_id: jobId }),
      },
    });
    return (response.data);
  };

export const fetchSofEntries = async (csofId: string) => {
  const response = await fetchSingleCsof(csofId);
  return response.data?.csof_entries || [];
};

export const deleteCsof = async (csofId: string) => {
  const response = await axiosServices.delete(`/csof/${csofId}`);
  return response.data;
};

export const updateSofEntry = async (csofEntryId: string, data: any) => {
  const response = await axiosServices.put(`/csof/entry/${csofEntryId}`, data);
  return response.data.data;
};

export const createSofEntry = async (data: { csof_id: string; job_id: string; [key: string]: any }) => {
  const response = await axiosServices.post("/csof/entry", data);
  return response.data?.data;
};

export const deleteSofEntry = async (csofEntryId: string) => {
  const response = await axiosServices.delete(`/csof/entry/${csofEntryId}`);
  return response.data;
};
